module.exports = __webpack_public_path__ + "media/images/royalslider/a-c3b12c9402cde19bc2a71c785890ccef.jpg";